var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverageApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 39,
    viewBox: "0 0 141 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.5147 11.6947L51.1015 10.6092L50.5147 11.6947ZM93.3894 2.58245L92.8824 3.70741L93.3894 2.58245ZM140.813 38.8069L136.732 25.1561L126.95 35.5159L140.813 38.8069ZM1.86364 11.859C8.07286 5.77373 15.5433 3.58291 23.7285 4.10548C31.9596 4.63099 40.9101 7.90529 49.9279 12.7801L51.1015 10.6092C41.9277 5.65009 32.6164 2.20008 23.8858 1.64269C15.1092 1.08236 6.91812 3.45006 0.136309 10.0965L1.86364 11.859ZM49.9279 12.7801C53.67 14.803 57.5275 14.7179 61.3021 13.6645C65.035 12.6227 68.8027 10.5998 72.4321 8.62928C76.1183 6.62792 79.667 4.67775 83.1401 3.58793C86.5812 2.50816 89.8059 2.32097 92.8824 3.70741L93.8963 1.4575C90.0772 -0.263586 86.1824 0.0468184 82.4012 1.23332C78.652 2.40979 74.8755 4.4946 71.2546 6.4605C67.577 8.45722 64.0558 10.3339 60.6388 11.2875C57.2635 12.2295 54.1102 12.2357 51.1015 10.6092L49.9279 12.7801ZM92.8824 3.70741C106.079 9.65462 122.315 23.3684 131.907 32.0953L133.568 30.2699C123.995 21.5605 107.496 7.58611 93.8963 1.4575L92.8824 3.70741Z",
    fill: "url(#paint0_linear_3_12378)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_12378",
    x1: 135.289,
    y1: 29.2443,
    x2: 68.752,
    y2: 78.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480335,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageApply);
export default __webpack_public_path__ + "static/media/average_apply.051a35f78c1d30edc3134b36ec3997e0.svg";
export { ForwardRef as ReactComponent };